import { Box, TabPanels, Tabs } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import {
    ContentTab,
    TabCustom,
    TabListCustom,
    TabPanelCustom,
    TabTitle
} from 'pages/Contract/styles'

import { ShippingFile } from 'pages/Report/components/ShippingFile'
import { Billing } from './components/Billing'
import { Closure } from './components/Closure'
import { DebitNote } from './components/DebitNote'
import { Finance } from './components/Finance'

export const FinancialManagement = () => {
    const bgTransparent = {
        background: 'transparent'
    }

    return (
        <Tabs
            isLazy
            style={bgTransparent}
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            height="100%"
        >
            <TabListCustom style={bgTransparent}>
                <ContentTab>
                    <TabCustom>Gestão Financeira</TabCustom>
                    <TabCustom>Gestão Fechamento</TabCustom>
                    <TabCustom>Gestão Faturamento</TabCustom>
                    <TabCustom>Arquivo Remessa</TabCustom>
                    <TabCustom>Nota de Débito</TabCustom>
                </ContentTab>
            </TabListCustom>

            <TabTitle pt={4} style={bgTransparent}></TabTitle>

            <TabPanels>
                <TabPanelCustom style={bgTransparent}>
                    <Box>
                        <Finance />
                    </Box>
                </TabPanelCustom>

                <TabPanelCustom style={bgTransparent}>
                    <Closure />
                </TabPanelCustom>

                <TabPanelCustom style={bgTransparent}>
                    <Billing />
                </TabPanelCustom>

                <TabPanelCustom style={bgTransparent}>
                    <ShippingFile />
                </TabPanelCustom>

                <TabPanelCustom style={bgTransparent}>
                    <DebitNote />
                </TabPanelCustom>
            </TabPanels>
        </Tabs>
    )
}